package dev.wyns.ventrova.ui.web

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.window.Popup
import androidx.compose.ui.window.PopupProperties
import androidx.compose.ui.zIndex
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import dev.wyns.ventrova.AppDependencies
import dev.wyns.ventrova.app.AppEnvironment
import dev.wyns.ventrova.app.AppUiState
import dev.wyns.ventrova.app.PlaceItem
import dev.wyns.ventrova.app.rememberAppEnvironment
import dev.wyns.ventrova.data.model.VeganLevel
import dev.wyns.ventrova.resources.Res
import dev.wyns.ventrova.resources.app_name
import dev.wyns.ventrova.resources.favorites
import dev.wyns.ventrova.resources.favorites_empty_web
import dev.wyns.ventrova.resources.favorites_tab
import dev.wyns.ventrova.resources.filter_open_now
import dev.wyns.ventrova.resources.filters
import dev.wyns.ventrova.resources.ic_add
import dev.wyns.ventrova.resources.ic_add_location_alt
import dev.wyns.ventrova.resources.ic_close
import dev.wyns.ventrova.resources.ic_expand_less
import dev.wyns.ventrova.resources.ic_expand_more
import dev.wyns.ventrova.resources.ic_favorite
import dev.wyns.ventrova.resources.ic_favorite_filled
import dev.wyns.ventrova.resources.ic_location_on
import dev.wyns.ventrova.resources.ic_near_me_filled
import dev.wyns.ventrova.resources.ic_remove
import dev.wyns.ventrova.resources.ic_schedule
import dev.wyns.ventrova.resources.ic_search
import dev.wyns.ventrova.resources.ic_tune
import dev.wyns.ventrova.resources.loading
import dev.wyns.ventrova.resources.map_attribution
import dev.wyns.ventrova.resources.nearby_nothing_found
import dev.wyns.ventrova.resources.nearby_tab
import dev.wyns.ventrova.resources.nearby_title
import dev.wyns.ventrova.resources.search_no_results_web
import dev.wyns.ventrova.resources.search_placeholder_long
import dev.wyns.ventrova.resources.search_results
import dev.wyns.ventrova.resources.suggest_place
import dev.wyns.ventrova.ui.components.FryOilLine
import dev.wyns.ventrova.ui.components.LevelGlyph
import dev.wyns.ventrova.ui.components.OpenStatusLine
import dev.wyns.ventrova.ui.components.PlaceListSkeleton
import dev.wyns.ventrova.ui.components.PlaceRowSkeleton
import dev.wyns.ventrova.ui.components.PlaceThumbnail
import dev.wyns.ventrova.ui.components.VIcon
import dev.wyns.ventrova.ui.components.bodyStyle
import dev.wyns.ventrova.ui.map.MapDecorations
import dev.wyns.ventrova.ui.map.MarkerStyle
import dev.wyns.ventrova.ui.map.PlacesMap
import dev.wyns.ventrova.ui.theme.ProvideVentrovaFonts
import dev.wyns.ventrova.ui.theme.VentrovaColors
import dev.wyns.ventrova.ui.theme.displayStyle
import dev.wyns.ventrova.ui.theme.distanceLabel
import dev.wyns.ventrova.ui.theme.geistFontFamily
import dev.wyns.ventrova.ui.theme.label
import dev.wyns.ventrova.ui.theme.messageText
import dev.wyns.ventrova.ui.theme.palette
import dev.wyns.ventrova.ui.theme.shortLabel
import dev.wyns.ventrova.ui.theme.withFontFamily
import kotlinx.browser.window
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent

private val WebDecorations = MapDecorations(
    markerStyle = MarkerStyle.Web,
    locationColor = VentrovaColors.LocationIos,
    radiusRingColor = VentrovaColors.Ink.copy(alpha = 0.45f),
    radiusRingFill = VentrovaColors.Ink.copy(alpha = 0.045f),
    radiusRingDashed = true,
)

private enum class SideTab { Nearby, Favorites }

/** Shared "pointer" cursor for everything clickable on the web. */
internal fun Modifier.handCursor() = pointerHoverIcon(PointerIcon.Hand)

/** The desktop web layout of the design: a sidebar with the list next to the map. */
@Composable
fun WebApp(dependencies: AppDependencies) {
    val body = geistFontFamily()
    MaterialTheme(typography = Typography().withFontFamily(body)) {
        ProvideVentrovaFonts(body = body) {
            val env = rememberAppEnvironment(dependencies)
            val state by env.viewModel.state.collectAsStateWithLifecycle()
            WebScreen(env, state)
        }
    }
}

@Composable
private fun WebScreen(env: AppEnvironment, state: AppUiState) {
    val viewModel = env.viewModel
    var hoveredId by remember { mutableStateOf<String?>(null) }
    // A row or marker only clears the hover it set itself, so composing rows doesn't reset it.
    val onHover: (String, Boolean) -> Unit = { id, hovered ->
        hoveredId = if (hovered) id else if (hoveredId == id) null else hoveredId
    }
    var filtersOpen by remember { mutableStateOf(false) }
    var suggestOpen by remember { mutableStateOf(false) }
    var sideTab by remember { mutableStateOf(SideTab.Nearby) }
    val searchFocus = remember { FocusRequester() }

    // "/" focuses the search field, like the keyboard hint in the design.
    val onboardingVisible by rememberUpdatedState(state.showOnboarding)
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = { event ->
            if ((event as? KeyboardEvent)?.key == "/" && !onboardingVisible) {
                event.preventDefault()
                searchFocus.requestFocus()
            }
        }
        window.addEventListener("keydown", listener)
        onDispose { window.removeEventListener("keydown", listener) }
    }

    BoxWithConstraints(Modifier.fillMaxSize().background(VentrovaColors.MapBackground)) {
        val narrow = maxWidth < 760.dp
        val sidebar = @Composable { modifier: Modifier ->
            Sidebar(
                state = state,
                env = env,
                sideTab = sideTab,
                onSideTab = { sideTab = it },
                hoveredId = hoveredId,
                onHover = onHover,
                filtersOpen = filtersOpen,
                onToggleFilters = { filtersOpen = !filtersOpen },
                onSuggest = { suggestOpen = true },
                searchFocus = searchFocus,
                modifier = modifier,
            )
        }
        val map = @Composable { modifier: Modifier ->
            MapArea(state, env, hoveredId, onHover = { id -> if (id != null) onHover(id, true) else hoveredId?.let { onHover(it, false) } }, onSuggest = { suggestOpen = true }, modifier = modifier)
        }
        if (narrow) {
            Column(Modifier.fillMaxSize()) {
                map(Modifier.fillMaxWidth().weight(0.45f))
                sidebar(Modifier.fillMaxWidth().weight(0.55f))
            }
        } else {
            Row(Modifier.fillMaxSize()) {
                sidebar(Modifier.width(420.dp).fillMaxHeight())
                map(Modifier.weight(1f).fillMaxHeight())
            }
        }

        if (suggestOpen) {
            WebSuggestModal(state.suggestion, viewModel, onClose = {
                suggestOpen = false
                viewModel.resetSuggestion()
            })
        }
        if (state.showOnboarding) WebOnboarding(env)

        state.message?.let { message ->
            WebToast(messageText(message.kind), onShown = { viewModel.consumeMessage(message) }, modifier = Modifier.align(Alignment.BottomCenter).padding(start = if (narrow) 0.dp else 420.dp, bottom = 28.dp))
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun Sidebar(
    state: AppUiState,
    env: AppEnvironment,
    sideTab: SideTab,
    onSideTab: (SideTab) -> Unit,
    hoveredId: String?,
    onHover: (String, Boolean) -> Unit,
    filtersOpen: Boolean,
    onToggleFilters: () -> Unit,
    onSuggest: () -> Unit,
    searchFocus: FocusRequester,
    modifier: Modifier,
) {
    val viewModel = env.viewModel
    Box(modifier.background(VentrovaColors.Canvas).zIndex(2f)) {
        Column(Modifier.fillMaxSize()) {
            Column(Modifier.padding(start = 22.dp, end = 22.dp, top = 20.dp, bottom = 14.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    Text(stringResource(Res.string.app_name), style = displayStyle(26, weight = FontWeight.ExtraBold, lineHeight = 1f))
                    state.nearby.firstOrNull()?.place?.address?.city?.let { city ->
                        Row(
                            Modifier.height(24.dp).background(VentrovaColors.SandDark, RoundedCornerShape(12.dp)).padding(start = 6.dp, end = 9.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(3.dp),
                        ) {
                            VIcon(Res.drawable.ic_location_on, size = 15.dp, tint = VentrovaColors.Secondary)
                            Text(city, style = bodyStyle(12.5.sp, color = VentrovaColors.Secondary))
                        }
                    }
                }
                SearchField(state.query, viewModel::setQuery, searchFocus)
                Box {
                    FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        val sheetCount = state.filters.sheetOnlyCount
                        val active = sheetCount > 0 || filtersOpen
                        WebChip(active = active, onClick = onToggleFilters, activeBackground = VentrovaColors.Ink, activeContent = Color.White, activeBorder = VentrovaColors.Ink, bold = true) {
                            VIcon(Res.drawable.ic_tune, size = 17.dp)
                            Text(stringResource(Res.string.filters), style = bodyStyle(13.5.sp, FontWeight.SemiBold, LocalContentColor.current))
                            if (sheetCount > 0) {
                                Box(Modifier.size(17.dp).background(Color.White, CircleShape), contentAlignment = Alignment.Center) {
                                    Text("$sheetCount", style = bodyStyle(11.sp, FontWeight.Bold))
                                }
                            }
                            VIcon(if (filtersOpen) Res.drawable.ic_expand_less else Res.drawable.ic_expand_more, size = 17.dp)
                        }
                        VeganLevel.entries.forEach { level ->
                            val selected = level in state.filters.levels
                            val palette = level.palette
                            WebChip(active = selected, onClick = { viewModel.toggleLevel(level) }, activeBackground = palette.soft, activeContent = palette.ink, activeBorder = palette.color) {
                                LevelGlyph(level, size = 11.dp)
                                Text(stringResource(level.shortLabel), style = bodyStyle(13.5.sp, FontWeight.Medium, LocalContentColor.current))
                                if (!state.isLoading) {
                                    Text("${state.levelCounts[level] ?: 0}", style = bodyStyle(13.5.sp, FontWeight.Medium, LocalContentColor.current.copy(alpha = 0.55f)))
                                }
                            }
                        }
                        WebChip(active = state.filters.openNow, onClick = viewModel::toggleOpenNow, activeBackground = VentrovaColors.Ink, activeContent = Color.White, activeBorder = VentrovaColors.Ink) {
                            VIcon(Res.drawable.ic_schedule, size = 17.dp)
                            Text(stringResource(Res.string.filter_open_now), style = bodyStyle(13.5.sp, FontWeight.Medium, LocalContentColor.current))
                        }
                    }
                    if (filtersOpen) {
                        Popup(
                            offset = with(LocalDensity.current) { IntOffset(0, 40.dp.roundToPx()) },
                            onDismissRequest = onToggleFilters,
                            properties = PopupProperties(focusable = true),
                        ) {
                            WebFilterPopover(state, viewModel, onClose = onToggleFilters, modifier = Modifier.width(376.dp))
                        }
                    }
                }
            }

            Row(Modifier.padding(horizontal = 22.dp), horizontalArrangement = Arrangement.spacedBy(18.dp)) {
                val nearbyLabel = if (state.query.isNotBlank()) {
                    pluralStringResource(Res.plurals.search_results, state.searchResults.size, state.searchResults.size)
                } else {
                    if (state.isLoading) stringResource(Res.string.nearby_title) else stringResource(Res.string.nearby_tab, state.nearby.size)
                }
                SideTabLabel(nearbyLabel, sideTab == SideTab.Nearby) { onSideTab(SideTab.Nearby) }
                val favoritesLabel = if (state.favoritesLoading) stringResource(Res.string.favorites) else stringResource(Res.string.favorites_tab, state.favorites.size)
                SideTabLabel(favoritesLabel, sideTab == SideTab.Favorites) { onSideTab(SideTab.Favorites) }
            }
            HorizontalDivider(color = VentrovaColors.Line)

            val items = when {
                state.query.isNotBlank() -> state.searchResults
                sideTab == SideTab.Favorites -> state.favorites
                else -> state.nearby
            }
            val loading = when {
                state.query.isNotBlank() -> state.isSearching && state.searchResults.isEmpty()
                sideTab == SideTab.Favorites -> state.favoritesLoading
                else -> state.isLoading
            }
            if (loading) {
                PlaceListSkeleton(count = 5, modifier = Modifier.padding(horizontal = 10.dp, vertical = 8.dp), loadingLabel = stringResource(Res.string.loading)) { index ->
                    PlaceRowSkeleton(Modifier.padding(12.dp), thumbSize = 92.dp, thumbShape = RoundedCornerShape(12.dp), spacing = 14.dp, seed = index)
                }
            } else if (items.isEmpty()) {
                Column(Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 48.dp), horizontalAlignment = Alignment.CenterHorizontally) {
                    val text = when {
                        state.query.isNotBlank() -> stringResource(Res.string.search_no_results_web)
                        sideTab == SideTab.Favorites -> stringResource(Res.string.favorites_empty_web)
                        else -> stringResource(Res.string.nearby_nothing_found)
                    }
                    Text(text, style = bodyStyle(14.5.sp, color = VentrovaColors.Muted), textAlign = TextAlign.Center)
                    Text(
                        stringResource(Res.string.suggest_place),
                        style = bodyStyle(14.5.sp, FontWeight.SemiBold, VentrovaColors.Accent),
                        modifier = Modifier.padding(top = 8.dp).handCursor().clickable(onClick = onSuggest),
                    )
                }
            }
            LazyColumn(Modifier.weight(1f), contentPadding = PaddingValues(start = 10.dp, end = 10.dp, top = 8.dp, bottom = 20.dp)) {
                items(items, key = { it.id }) { item ->
                    WebPlaceRow(
                        item = item,
                        highlighted = item.id == hoveredId || item.id == state.detail?.id,
                        onHover = onHover,
                        onOpen = {
                            viewModel.openDetail(item.id)
                            env.focus(item, fractionX = 0.5f, fractionY = 0.45f)
                        },
                        onToggleFavorite = { viewModel.toggleFavorite(item.id) },
                    )
                }
            }
        }

        AnimatedVisibility(
            visible = state.detail != null,
            enter = fadeIn(tween(200)) + slideInHorizontally(tween(320)) { -it / 18 },
            exit = fadeOut(tween(150)) + slideOutHorizontally(tween(250)) { -it / 18 },
        ) {
            state.detail?.let { WebDetail(it, state.detailMenu, env) }
        }
    }
}

@Composable
private fun SearchField(query: String, onQuery: (String) -> Unit, focus: FocusRequester) {
    Row(
        Modifier.fillMaxWidth().height(44.dp).background(Color.White, RoundedCornerShape(12.dp)).border(1.dp, VentrovaColors.LineStrong, RoundedCornerShape(12.dp)).padding(horizontal = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        VIcon(Res.drawable.ic_search, size = 20.dp, tint = VentrovaColors.Muted)
        Box(Modifier.weight(1f)) {
            if (query.isEmpty()) Text(stringResource(Res.string.search_placeholder_long), style = bodyStyle(15.sp, color = VentrovaColors.Subtle), maxLines = 1)
            BasicTextField(
                value = query,
                onValueChange = onQuery,
                singleLine = true,
                textStyle = bodyStyle(15.sp),
                cursorBrush = SolidColor(VentrovaColors.Ink),
                modifier = Modifier.fillMaxWidth().focusRequester(focus),
            )
        }
        if (query.isNotEmpty()) {
            VIcon(Res.drawable.ic_close, size = 18.dp, tint = VentrovaColors.Muted, modifier = Modifier.handCursor().clickable { onQuery("") })
        }
        Box(Modifier.border(1.dp, VentrovaColors.Line, RoundedCornerShape(5.dp)).padding(horizontal = 5.dp, vertical = 2.dp)) {
            Text("/", style = bodyStyle(11.sp, FontWeight.Medium, Color(0xFF9A9C94)))
        }
    }
}

@Composable
internal fun WebChip(
    active: Boolean,
    onClick: () -> Unit,
    activeBackground: Color,
    activeContent: Color,
    activeBorder: Color,
    bold: Boolean = false,
    height: Dp = 32.dp,
    content: @Composable () -> Unit,
) {
    val interaction = remember { MutableInteractionSource() }
    val hovered by interaction.collectIsHoveredAsState()
    val shape = RoundedCornerShape(8.dp)
    CompositionLocalProvider(LocalContentColor provides if (active) activeContent else VentrovaColors.Ink) {
        Row(
            Modifier
                .height(height)
                .clip(shape)
                .background(if (active) activeBackground else Color.White)
                .border(1.dp, if (active) activeBorder else if (hovered) VentrovaColors.Ink else VentrovaColors.LineStrong, shape)
                .hoverable(interaction)
                .handCursor()
                .clickable(onClick = onClick)
                .padding(start = 8.dp, end = if (bold) 10.dp else 11.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(5.dp),
        ) { content() }
    }
}

@Composable
private fun SideTabLabel(text: String, active: Boolean, onClick: () -> Unit) {
    Column(Modifier.width(IntrinsicSize.Max).handCursor().clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = onClick)) {
        Text(text, style = bodyStyle(14.sp, FontWeight.SemiBold, if (active) VentrovaColors.Ink else VentrovaColors.Muted), modifier = Modifier.padding(top = 8.dp, bottom = 10.dp))
        Box(Modifier.height(2.dp).fillMaxWidth().background(if (active) VentrovaColors.Ink else Color.Transparent))
    }
}

@Composable
private fun WebPlaceRow(item: PlaceItem, highlighted: Boolean, onHover: (String, Boolean) -> Unit, onOpen: () -> Unit, onToggleFavorite: () -> Unit) {
    val interaction = remember { MutableInteractionSource() }
    val hovered by interaction.collectIsHoveredAsState()
    LaunchedEffect(hovered) { if (hovered) onHover(item.id, true) else onHover(item.id, false) }
    val place = item.place
    val palette = place.veganLevel.palette
    Row(
        Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .background(if (highlighted || hovered) VentrovaColors.Sand else Color.Transparent)
            .hoverable(interaction)
            .handCursor()
            .clickable(onClick = onOpen)
            .padding(12.dp),
        horizontalArrangement = Arrangement.spacedBy(14.dp),
    ) {
        PlaceThumbnail(place, Modifier.size(92.dp), RoundedCornerShape(12.dp), iconSize = 28.dp)
        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(place.name, style = displayStyle(17, lineHeight = 1.15f), modifier = Modifier.weight(1f), maxLines = 2, overflow = TextOverflow.Ellipsis)
                VIcon(
                    if (item.isFavorite) Res.drawable.ic_favorite_filled else Res.drawable.ic_favorite,
                    size = 20.dp,
                    tint = if (item.isFavorite) VentrovaColors.Favorite else VentrovaColors.Ink,
                    modifier = Modifier.handCursor().clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = onToggleFavorite),
                )
            }
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                LevelGlyph(place.veganLevel, size = 10.dp)
                Text(stringResource(place.veganLevel.label), style = bodyStyle(13.sp, FontWeight.SemiBold, palette.ink))
                Text("· " + stringResource(place.category.label), style = bodyStyle(13.sp, color = VentrovaColors.Muted), maxLines = 1)
            }
            FryOilLine(place)
            OpenStatusLine(
                item,
                style = bodyStyle(13.sp, color = VentrovaColors.Secondary),
                suffix = item.distanceMeters?.let { distanceLabel(it) },
            )
        }
    }
}

@Composable
private fun MapArea(state: AppUiState, env: AppEnvironment, hoveredId: String?, onHover: (String?) -> Unit, onSuggest: () -> Unit, modifier: Modifier) {
    val viewModel = env.viewModel
    Box(modifier) {
        PlacesMap(
            controller = env.map,
            places = state.nearby,
            selectedId = state.detail?.id,
            highlightedId = hoveredId,
            decorations = WebDecorations,
            onMarkerClick = {
                viewModel.openDetail(it.id)
                env.focus(it, fractionX = 0.5f, fractionY = 0.45f)
            },
            onMapClick = { viewModel.selectPlace(null) },
            onViewportChanged = viewModel::onViewportChanged,
            onMarkerHover = onHover,
            userLocation = state.userLocation,
            radiusCenter = state.referencePoint,
            radiusKm = state.filters.radiusKm,
            modifier = Modifier.fillMaxSize(),
        )
        Row(
            Modifier
                .align(Alignment.TopEnd)
                .padding(16.dp)
                .height(40.dp)
                .shadow(4.dp, RoundedCornerShape(10.dp))
                .background(Color.White, RoundedCornerShape(10.dp))
                .handCursor()
                .clickable(onClick = onSuggest)
                .padding(start = 11.dp, end = 14.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(6.dp),
        ) {
            VIcon(Res.drawable.ic_add_location_alt, size = 19.dp, tint = VentrovaColors.Ink)
            Text(stringResource(Res.string.suggest_place), style = bodyStyle(14.sp, FontWeight.SemiBold))
        }
        Column(Modifier.align(Alignment.BottomEnd).padding(end = 16.dp, bottom = 28.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            MapButton(onClick = env::locate) { VIcon(Res.drawable.ic_near_me_filled, size = 20.dp, tint = VentrovaColors.LocationIos) }
            Column(Modifier.width(40.dp).shadow(4.dp, RoundedCornerShape(10.dp)).background(Color.White, RoundedCornerShape(10.dp))) {
                Box(Modifier.size(40.dp).handCursor().clickable { env.zoomBy(1.0) }, contentAlignment = Alignment.Center) {
                    VIcon(Res.drawable.ic_add, size = 20.dp, tint = VentrovaColors.Ink)
                }
                Box(Modifier.padding(horizontal = 8.dp).height(1.dp).fillMaxWidth().background(VentrovaColors.SandDark))
                Box(Modifier.size(40.dp).handCursor().clickable { env.zoomBy(-1.0) }, contentAlignment = Alignment.Center) {
                    VIcon(Res.drawable.ic_remove, size = 20.dp, tint = VentrovaColors.Ink)
                }
            }
        }
        Text(
            stringResource(Res.string.map_attribution),
            style = bodyStyle(10.sp, color = VentrovaColors.Ink.copy(alpha = 0.55f)),
            modifier = Modifier.align(Alignment.BottomStart).padding(start = 10.dp, bottom = 6.dp),
        )
    }
}

@Composable
private fun MapButton(onClick: () -> Unit, content: @Composable () -> Unit) {
    Box(
        Modifier.size(40.dp).shadow(4.dp, RoundedCornerShape(10.dp)).background(Color.White, RoundedCornerShape(10.dp)).handCursor().clickable(onClick = onClick),
        contentAlignment = Alignment.Center,
    ) { content() }
}
